<script>
import { VDialog } from "vuetensils/src/components";
export default VDialog;
</script>
